import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import analytics from '../../../../modules/analytics';

import SearchBoostNotification from './SearchBoostNotification';

const SearchBoostNotificationContainer = ({ notification }) => {
  const {
    providerId,
    daysLeft,
  } = notification;
  const [text, setText] = useState(null);
  const elapsed = 7 - daysLeft;
  const timestamp = !elapsed ? '1 HOUR AGO' : `${elapsed} DAY${elapsed > 1 ? 'S' : ''} AGO`;

  useEffect(() => {
    const promoteButtonParams = {
      buttonText: 'Share Profile',
      link: 'responsive.provider.promote',
      linkParams: { providerId },
      eventName: 'pro_searchboostnotification_share_profile_click',
    };

    switch (daysLeft) {
      case 7:
      case 6:
      case 5:
      case 4:
      case 3:
      case 2:
      case 1:
        setText({
          ...promoteButtonParams,
          topEmphasize: 'You earned a search boost!',
          top: 'This pushes your business up in client searches in your area.',
          sent: timestamp,
          bottomEmphasize: 'Share your profile,',
          bottom: 'the more traffic you get now, the higher up you’ll appear in future client searches',
        });
        break;
      default:
        setText({
          ...promoteButtonParams,
          topEmphasize: 'Your Search Boost is complete!',
          top: 'We boosted your profile up in client searches in your area.',
          sent: '7 DAYS AGO',
          bottomEmphasize: 'Keep your momentum.',
          bottom: 'The more traffic you get to your profile, the higher up you’ll appear in client searches.',
        });
        break;
    }

    analytics.track('pro_searchboostnotification_viewed', {
      days_left_in_boost: daysLeft,
      provider_id: providerId,
    });
  }, [daysLeft]);

  return (
    <SearchBoostNotification notification={notification} {...text} />
  );
};

SearchBoostNotificationContainer.propTypes = {
  notification: PropTypes.shape({
    providerId: PropTypes.string,
    daysLeft: PropTypes.number,
  }).isRequired,
};

export default SearchBoostNotificationContainer;
